import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ConnectedUser } from '../../connection/socket';
import { Profile } from '../../stores/reducers/invitations';
import { getNameOrInitials } from '../../utils/utils';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { DRAG_TYPE } from '../../stores/reducers/user-interface';
import useDragItem from '../../hooks/use-dnd/use-drag-item';

interface Props {
	connectedPresenter?: ConnectedUser;
	invitedPresenter?: Profile;
	isOnCanvas: boolean;
}

export default function ScreenShareLink(props: Props) {
	const host = useSelector((state: any) => state.SessionReducer.host);

	const {
		connectedPresenter,
		invitedPresenter,
		isOnCanvas,
	} = props;

	const presenter = useMemo(() => {
		if (connectedPresenter) {
			return connectedPresenter;
		} if (invitedPresenter) {
			return invitedPresenter;
		}
		return {
			email: '',
			first_name: '',
			last_name: '',
			avatar: '',
			poster: '',
			job_title: '',
			gr_user: 0,
		} as Profile;
	}, [connectedPresenter, invitedPresenter]);

	const { dragRef, isDragging } = useDragItem(
		{ id: presenter?.email, type: DRAG_TYPE.FEED_SCREENSHARE },
		host,
	);

	return (
		<React.Fragment>
			{isDragging && (<div className="media-link-drag-placeholder" />)}
			<div
				className={classNames('padding-top-medium', {
					'link-is-highlighted': isOnCanvas,
					'link-is-dragging': isDragging,
				})}
			>
				<div
					className={classNames('screenshare-link padding-medium', {
						'cursor-grab': host,
					})}
					onFocus={(e) => e.currentTarget.blur()}
					ref={dragRef}
				>
					<div className="screenshare-thumbnail">
						<Icon name={ICONS.SHARE_SCREEN} color={COLORS.WHITE} size={30} />
					</div>
					<div className="screenshare-info">
						<span>{getNameOrInitials(presenter, true)}</span>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}
